import Bubble from '@/legacy-src/components/Bubble'
import type { TherapistType } from '@/legacy-src/types/TherapistStateType'
import { getTranslate } from '@/legacy-src/utilities/i18n'

import { Heading } from '@/src/domains/design-system/components/Heading'
import { Tag } from '@/src/domains/design-system/components/Tag'

import { TherapistsPreviewInRegistrationTitle } from './TherapistsPreviewInRegistrationTitle'

export interface TherapistsPreviewInRegistrationVersionBProps {
  therapist: TherapistType
  nameVocative?: string
}

export const TherapistsPreviewInRegistrationVersionB = ({
  therapist,
  nameVocative,
}: TherapistsPreviewInRegistrationVersionBProps) => {
  const { t } = getTranslate()

  return (
    <>
      <div className="mb-10">
        <TherapistsPreviewInRegistrationTitle nameVocative={nameVocative} sex={therapist.sex} />
      </div>
      <div className="-mb-10 overflow-hidden rounded-3xl">
        <div className="flex w-full items-start gap-5 bg-blue-500 p-5 blur-[1.5px] tablet:gap-5">
          <Bubble
            imgUrl={therapist.image ?? '/images/svg/misc/therapist-placeholder.svg'}
            sizeClass="w-20 h-20"
            className="inline-block shrink-0"
          />

          <div className="flex flex-1 flex-col items-start gap-2">
            <Tag size="xs" variant="yellow">
              {t('diagnosisTest.register.therapist.experience', {
                experience: therapist.experience,
              })}
            </Tag>
            <Heading element="h2" variant="xl" className="m-0">
              {therapist.firstName} {therapist.lastName}
            </Heading>
          </div>
        </div>
      </div>
    </>
  )
}
